import * as queries from "./queries";

export const admin = { queries };
